<script lang="ts">
  import { parseISO } from "date-fns";
  import type { OrderDetail } from "../helpers/types";
  import TextNew from "./TextNew.svelte";

  export let order: OrderDetail;

  $: formattedDate = () => {
    if (!order || !order.delivery_on) return "";

    return new Intl.DateTimeFormat("en-GB", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      timeZone: "UTC",
    }).format(parseISO(order.delivery_on));
  };

  $: orderEmails = () => {
    if (!order || !order.emails) return "";

    return order.emails.join(", ");
  };
</script>

<div class="container">
  <div class="header">
    <TextNew size="m" font="ocr">summary</TextNew>
  </div>
  <div class="content">
    <div class="column">
      <TextNew size="s" --rk-text-color="var(--rk-text-transparency-dark)">supplier name</TextNew>
      <TextNew size="s" --rk-text-color="var(--rk-text-transparency-dark)">address</TextNew>
      <TextNew size="s" --rk-text-color="var(--rk-text-transparency-dark)">delivery on</TextNew>
      <TextNew size="s" --rk-text-color="var(--rk-text-transparency-dark)">email</TextNew>
    </div>
    <div class="column right">
      <TextNew size="s">{order.supplier_name}</TextNew>
      <TextNew size="s">{order.location_address}</TextNew>
      <TextNew size="s">{formattedDate()}</TextNew>
      <TextNew size="s">{orderEmails()}</TextNew>
    </div>
  </div>
</div>

<style>
  .container {
    display: flex;
    flex: 0;
    flex-direction: column;
  }

  .header {
    background-color: var(--rekki-neutral-02);
    padding: 9px 16px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .content {
    display: flex;
    flex-direction: row;
    padding: 21px 16px;
    gap: 16px;
    border: solid 1px #ebebeb;
    border-top: 0px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .column {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .right {
    flex: 1;
  }
</style>
